import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import IntlMessages from "../../util/IntlMessages";
import {
  Layout,
  Card,
  Table,
  Button,
  Input,
  Row,
  Col,
  Form,
  Select,
  Collapse,
  Panel,
  Modal,
  message,
  Spin,
  Space,
  Tag,
} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import Skeleton from "react-loading-skeleton";
import CustomerGroupImg from "../../assets/images/customer-groups.png";
import ds from "../../Services/DataServices";
import useModal from "antd/lib/modal/useModal";
import { loadData } from "../../appRedux/actions/Setting";
import moment from "moment";
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
} from "../../appRedux/actions/GlobalMethods";
import { setCommonConfigs } from "../../appRedux/actions/CommonData";
import { CUSTOMER_GROUP } from "../../constants/Pages";
import { BEHAVIOUR_TYPE } from "../../Services/DataServices";
import NotAllowedComponent from "../../components/NotAllowedComponent";

const CustomerGroup = () => {
  const [form] = Form.useForm();
  const Panel = Collapse.Panel;
  const history = useHistory();
  const dispatch = useDispatch();
  const confirm = Modal.confirm;

  // const loadDataRedux = useSelector(({ settings }) => settings.loadData);
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );

  const [Loader, setLoader] = useState(true);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [visible, setvisible] = useState(false);
  const [getMappedData, setMappedData] = useState([]);
  const [isEdit, setIsEdit] = useState([]);
  const [getLoadData, setLoadData] = useState(false);
  const [getIsDisableCreate, setIsDisableCreate] = useState(true);
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true);
  const [getIsDisableDelete, setIsDisableDelete] = useState(true);
  const [getIsAllowRead, setIsAllowRead] = useState(false);
  const [getAccessLoading, setAccessLoading] = useState(true);
  const [getRights, setRights] = useState([]);
  const [getPermissions, setPermissions] = useState([]);
  const [getCurrData, setCurrData] = useState({
    currencyCode: "",
    currencySymbol: "",
  });
  const [getPagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10,
  });
  //const DeleteContext = createContext();
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      dispatch(setCommonConfigs(CUSTOMER_GROUP));
    }

    return () => (mounted = false);
  }, []);

  useEffect(() => {
    let body = { CurrentPageNo: getPagination.current };
    getListOfCustomerGroup(body);
  }, [getLoadData]);

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      const commonData = getReduxCommonSetting;
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {};
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrData(currencyData);
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData);
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData);
          setAccessLoading(false);
        } else {
          toInitialState();
          setAccessLoading(false);
        }
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);

  async function getListOfCustomerGroup(body) {
    setLoader(true);
    const getCustomerGroupData = ds.listCustomerGroup(body, BEHAVIOUR_TYPE.GET);
    await getCustomerGroupData
      .then((response) => {
        setLoader(false);
        if (response != null) {
          let groups = response.filter(
            (a) => a.customerGroupName != "All Customers"
          );
          let apiData = groups.map((data, index) => {
            return {
              key: index,
              groupName: data.customerGroupName,
              dateCreated: data.createdDateTime, //moment(data.createdDateTime).format("YYYY-MM-DD"),
              numberOfCustomers: data.noOfCounts,
              sid: data._CustomerSId,
            };
          });
          setMappedData(apiData);

          let paginationObj = {
            current: body.CurrentPageNo,
            pageSize: getPagination.pageSize,
            total: response.length > 0 ? response[0].totalRecords : 0,
          };
          setPagination(paginationObj);
        }
      })
      .catch((e) => {
        setLoader(false);
        notAllowMsgCheck(e);
      });
  }
  function toInitialState() {
    setRights([]);
    setPermissions([]);
    setIsAllowRead(false);
    setIsDisableCreate(true);
    setIsDisableUpdate(true);
    setIsDisableDelete(true);
    setAccessLoading(true);
  }

  function setupRightsPermissions(rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights);
    } else {
      setRights([]);
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions);
    } else {
      setPermissions([]);
    }
    if (rpData.read) {
      setIsAllowRead(true);
    } else {
      setIsAllowRead(false);
    }
    if (rpData.create) {
      setIsDisableCreate(false);
    } else {
      setIsDisableCreate(true);
    }
    if (rpData.update) {
      setIsDisableUpdate(false);
    } else {
      setIsDisableUpdate(true);
    }
    if (rpData.delete) {
      setIsDisableDelete(false);
    } else {
      setIsDisableDelete(true);
    }
  }

  const columns = [
    {
      title: <IntlMessages id="customergroupz.table.col1" />,
      dataIndex: "groupName",
      key: "groupName",
      render: (text, record) => {
        return <strong style={{ color: "#7a7a7a" }}>{text}</strong>;
      },
    },
    {
      title: <IntlMessages id="customergroupz.table.col2" />,
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (text, record) => {
        let isShow = true;
        if (record && record.sid) {
          let check = record.sid.substring(0, record.sid.indexOf("&"));
          isShow = check == "0" ? false : true;
        }
        let date = "   - - -  - - -";
        if (text && text != "" && isShow) {
          date = new Date(text);
          date = date.toLocaleString();
        }
        return <span>{date}</span>;
      },
    },
    {
      title: <IntlMessages id="customergroupz.table.col3" />,
      dataIndex: "numberOfCustomers",
      key: "numberOfCustomers",
      render: (text, record) => {
        return <span>{`${text}`}</span>;
      },
    },
    {
      title: <IntlMessages id="customergroupz.table.col4" />,
      key: "viewCustomers",
      render: (text, record) => (
        <>
          <div>
            <strong>
              <a
                className="gx-link"
                onClick={() => {
                  history.push(
                    `/Dashboard/customers/addcustomer/groupId=${record.sid}`
                  );
                }}
              >
                <IntlMessages id="customers.groupLabel.viewCustomers" />
              </a>
            </strong>
          </div>
        </>
      ),
    },
    {
      title: <IntlMessages id="products.brands.edit" />,
      key: "edit",
      render: (text, record) =>
        getIsDisableUpdate ? (
          <Tag color="#f50">
            <strong>
              <IntlMessages id="dakarpos.allow.accessdenied" />
            </strong>
          </Tag>
        ) : (
          <>
            <span>
              <a
                onClick={() => handleEdit(record.groupName, record.sid)}
                className="pen-edit"
              >
                <i className="icon icon-edit" />
              </a>
            </span>
            {/* <div>
            <Row>
              <Col span={12} lg={12} md={4} sm={4} xs={4}>
                <a
                  className="link-text"
                  style={{ fontSize: 12 }}
                  onClick={() => {
                    history.push(
                      `/Dashboard/customers/addcustomer/groupId=${record.sid}`
                    );
                  }}
                >
                  <IntlMessages id="customers.groupLabel.viewCustomers" />
                </a>
              </Col>
              <Col space={6}>
                <Space size="large">
                  <EditOutlined
                    onClick={() => handleEdit(record.groupName, record.sid)}
                  />

                  <DeleteOutlined
                    onClick={() =>
                      showConfirmDelete(record.sid, record.groupName)
                    }
                  />
                </Space>
              </Col>
            </Row>
          </div> */}
          </>
        ),
    },
    {
      title: <IntlMessages id="products.brands.delete" />,
      key: "delete",
      render: (text, record) =>
        getIsDisableDelete ? (
          <Tag color="#f50">
            <strong>
              <IntlMessages id="dakarpos.allow.accessdenied" />
            </strong>
          </Tag>
        ) : (
          <>
            <a className='trash-icon-btn' onClick={() => showConfirmDelete(record.sid, record.groupName)} >
              <i className="icon icon-trash" />
            </a>
            {/* <div>
            <DeleteOutlined
              onClick={() => showConfirmDelete(record.sid, record.groupName)}
            />
          </div> */}
          </>
        ),
    },
    // {
    //   key: "delete",
    //   render: (text, record) => (
    //     <>
    //       <div>
    //       <DeleteOutlined  onClick={()=>showConfirmDelete(record.sid,record.groupName)}/>

    //       </div>
    //     </>
    //   ),
    // },
  ];

  const handleCancel = () => {
    setConfirmLoading(false);
    setvisible(false);
    form.resetFields();
  };

  const handleDelete = (id) => {
    setConfirmLoading(true);
    ds.addCustomerGroup(
      { BehaviorName: 2, CustomerId: id },
      BEHAVIOUR_TYPE.DELETE
    )
      .then((res) => {
        setConfirmLoading(false);
        if (res && res == "Deleted") {
          message.success("Data deleted successfully");
          let newArray = getMappedData.filter((a) => a.sid !== id);
          setMappedData(newArray);
          // dispatch(loadData(true));
          setLoadData(!getLoadData);
        } else if (res && res == "Assign Group") {
          message.warn("Caution: This group is assign to Customer", 4);
        }
      })
      .catch((error) => {
        notAllowMsgCheck(error);
        message.error("Unable to delete data");
        setConfirmLoading(false);
      });
  };

  const showConfirmDelete = (id, groupName) => {
    confirm({
      title: "Delete ?",
      content: `"Are you sure you want to delete ${groupName}"`,
      okText: "Yes",
      cancelText: "No",
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
      onOk() {
        handleDelete(id);
      },
      onCancel() {},
    });
  };

  const handleOk = async (values) => {
    setConfirmLoading(true);

    if (!isEdit) {
      ds.addCustomerGroup(
        {
          CustomerGroupName: values.customerGroupText,
          BehaviorName: 1,
        },
        BEHAVIOUR_TYPE.POST
      )
        .then((res) => {
          setConfirmLoading(false);
          form.resetFields();
          setvisible(false);
          message.success("Customer group created Successfully");
          // dispatch(loadData(true));
          setLoadData(!getLoadData);
        })
        .catch((error) => {
          notAllowMsgCheck(error);
          setConfirmLoading(false);
         // console.log(error);
          message.error("Unable to create customer group");
        });
    } else {
      ds.addCustomerGroup(
        {
          CustomerId: values.customerGroupIdHidden,
          BehaviorName: 3,
          CustomerGroupName: values.customerGroupText,
        },
        BEHAVIOUR_TYPE.UPDATE
      )
        .then((res) => {
          setConfirmLoading(false);
          form.resetFields();
          setvisible(false);
          message.success("Customer group updated Successfully");
          // dispatch(loadData(true));
          setLoadData(!getLoadData);
          //message.success("Customer group created successfully");
        })
        .catch((error) => {
          notAllowMsgCheck(error);
          setConfirmLoading(false);
         // console.log(error);
          message.error("Unable to update customer group");
        });
    }
  };

  const handleEdit = (editName, id) => {
    setIsEdit(true);
    setvisible(true);
    form.setFieldsValue({
      customerGroupText: editName,
      customerGroupIdHidden: id,
    });
  };

  const handleAdd = () => {
    setIsEdit(false);
    setvisible(true);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    let body = { CurrentPageNo: pagination.current };
    getListOfCustomerGroup(body);
  };
  return getIsAllowRead ? (
    <>
      <Spin
        spinning={confirmLoading}
        tip={<IntlMessages id="sell.cashlisting.cashloading" />}
        size="large"
      >
        <div className="Content-wrapper CustomerGroups-pg">
          
        <Row className="back-arrow-h1 align-items-center justify-content-center mb-1 Customerspg-header mb-3">
        <Col lg={12} md={12} sm={24} xs={24}>
                <h1 className="mb-0">
                  <IntlMessages id="customers.customerGroupTitle" />
                </h1>
              </Col>

              <Col lg={12} md={12} sm={24} xs={24}>
            <div className="text-right">
                  <Button
                    className="dk-btn-add"
                    type="primary"
                    onClick={() => handleAdd()}
                    size="large"
                    disabled={getIsDisableCreate}
                  >
                    <IntlMessages id="customers.customerGroupAddBut" />
                  </Button>
                </div>
              </Col>
            </Row>
          

          <Card className="gx-card" title="">
            <Collapse>
              <Panel
                className="custom-promolist-help"
                showArrow={false}
                header={<IntlMessages id="customers.customerGroupTitle" />}
              >
                <Row>
                  <div className="billing-main">
                    <Col className="custom-promolist-helpdesc" md={12}>
                      <p>
                        <IntlMessages id="customer.helpdesc1" />
                      </p>
                      <p>
                        <IntlMessages id="customer.helpdesc2" />
                      </p>
                    </Col>

                    <Col md={12}>
                      <img src={CustomerGroupImg} alt="" />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>

          <div className="custom-product-table">
          <Card className="noborder table-body">
            {Loader ? (
              <Skeleton count={7} height={35} />
            ) : (
              <Table
                className="gx-table-responsive"
                key={getMappedData.key}
                columns={columns}
                dataSource={getMappedData}
                pagination={getPagination}
                onChange={handleTableChange}
              />
            )}
          </Card>
          </div>

          <Modal
            title={
              isEdit ? (
                <IntlMessages id="customer.editCustomer.groupTitle" />
              ) : (
                <IntlMessages id="customer.addCustomer.groupTitle" />
              )
            }
            visible={visible}
            okText={
              <span className="dk-btn-add">
                <IntlMessages id="common.resource.submit" />
              </span>
            }
            cancelText={
              <span className="dk-btn-cancel">
                <IntlMessages id="common.resource.cancel" />
              </span>
            }
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            centered={true}
            onOk={() => {
              form
                .validateFields()
                .then((values) => {
                  handleOk(values);
                })
                .catch((info) => {
                  // console.log("Validate info",info)
                });
            }}
            okButtonProps={{
              className: "dk-btn-add",
            }}
            cancelButtonProps={{
              className: "dk-btn-cancel",
            }}
          >
            <Form
              form={form}
              layout="vertical"
              name="addCustomerGroup"
              initialValues={{
                modifier: "public",
              }}
            >
              <Form.Item
                name={"customerGroupText"}
                label={
                  <IntlMessages id="customer.addCustomer.groupNameLabel" />
                }
                rules={[
                  {
                    required: true,
                    message: (
                      <IntlMessages id="customer.addCustomerValidation.required" />
                    ),
                  },
                ]}
              >
                <Input maxLength={30} size="large" />
              </Form.Item>
              <Form.Item name={"customerGroupIdHidden"}>
                <Input size="large" type="hidden" />
              </Form.Item>
            </Form>
          </Modal>
        </div>
      </Spin>
    </>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  );
};

export default CustomerGroup;
